import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PerpetualLicensesRepositoryService {
    constructor(http) {
        this.http = http;
    }
    listByAccountId(accountId) {
        return this.http.get(`${environment.apiUrl}v1/accounts/${accountId}/perpetual-licenses`);
    }
}
PerpetualLicensesRepositoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PerpetualLicensesRepositoryService_Factory() { return new PerpetualLicensesRepositoryService(i0.ɵɵinject(i1.HttpClient)); }, token: PerpetualLicensesRepositoryService, providedIn: "root" });
